import React from "react";

const FAQs = function () {
    const faqData = [
        {
            id: "faq_001",
            title: "How hydrolysed is Cow & Gate Hydrolysed nutriprem?",
        },
        {
            id: "faq_002",
            title: "How should Neocate Syneo be prepared?",
        },
        {
            id: "faq_003",
            title: "How long can Neocate LCP be stored in a fridge for?",
        },
        {
            id: "faq_004",
            title: "How long can Neocate Syneo be stored in a fridge for?",
        },
        {
            id: "faq_005",
            title: "What is the hanging time for Neocate Syneo?",
        },
        {
            id: "faq_006",
            title: "What is the hanging time for Neocate LCP?",
        },
        {
            id: "faq_007",
            title: "How do you advise introducing a new hypoallergenic formula?",
        },
        {
            id: "faq_008",
            title: "What is the probiotic used in the Syneo products?",
        },
        {
            id: "faq_009",
            title: "Why is Aptamil Pepti range suitable for Kosher but not Halal diets?",
        },
        {
            id: "faq_010",
            title: "What are the contraindications for Aptamil Pepti Syneo?",
        },
        {
            id: "faq_011",
            title: "What are the contraindications for Neocate Syneo?",
        },
        {
            id: "faq_012",
            title: "Why is Aptamil Pepti Syneo contraindicated in some patient groups?",
        },
        {
            id: "faq_013",
            title: "Why is Neocate Syneo contraindicated in some patient groups?",
        },
        {
            id: "faq_014",
            title: "Can the Fortini range of products be frozen?",
        },
        {
            id: "faq_015",
            title: "Can the Fortini range of products be heated?",
        },
        {
            id: "faq_016",
            title: "What is the standard concentration of Aptamil Pepti Junior?",
        },
        {
            id: "faq_017",
            title: "Is Aptamil Pepti Junior suitable for CMA?",
        },
        {
            id: "faq_018",
            title: "Is Nutrini Peptisorb Energy suitable for CMA?",
        },
        {
            id: "faq_019",
            title: "Can medication be administered together with the feed?",
        },
        {
            id: "faq_020",
            title: "How long can feeds be hung for?",
        },
        {
            id: "faq_021",
            title: "Can the two feeds be mixed together?",
        },
        {
            id: "faq_022",
            title: "Where can I find out more about reducing plastic usage in enteral nutrition?",
        },
        {
            id: "faq_023",
            title: "Can products be stored at a low temperature?",
        },
        {
            id: "faq_024",
            title: "Which containers are recyclable?",
        },
        {
            id: "faq_025",
            title: "Diabetes - taking an ONS if you have Diabetes",
        },
        {
            id: "faq_026",
            title: "Polycal and Oral Glucose Tolerance Testing",
        },
        {
            id: "faq_027",
            title: "I'd like to request some training for Nutilis Clear",
        },
        {
            id: "faq_028",
            title: "What are the IDDSI levels of your oral nutritional supplements?",
        },
        {
            id: "faq_029",
            title: "What adult allergens do you list on your products?",
        },
        {
            id: "faq_030",
            title: "Does Cow & Gate Hydrolysed nutriprem contain prebiotics?",
        },
        {
            id: "faq_031",
            title: "What is the MCT content of Neocate Syneo?",
        },
        {
            id: "faq_032",
            title: "What is the MCT content of Neocate LCP?",
        },
        {
            id: "faq_033",
            title: "How should Aptamil Pepti Syneo be prepared?",
        },
        {
            id: "faq_034",
            title: "I'd like to order a sample",
        },
    ];

    const handleAskQuestion = (faq) => {
        // initialize chatbot
        if (!window.BE_API.isInitialized()) {
            window.BE_API.create();
        }
        // send the FAQ question to the chatbot
        window.BE_API.sendMessage({
            message: faq.title,
        });
    };

    return React.createElement(
        "div",
        { className: "support-faqs" },
        React.createElement(
            "div",
            { className: "support-faqs__content" },
            faqData.map((faq, index) =>
                React.createElement(
                    "div",
                    {
                        key: index,
                        className: "support-faqs__item",
                    },
                    React.createElement(
                        "h3",
                        { className: "support-faqs__question" },
                        faq.title,
                    ),
                    React.createElement(
                        "button",
                        {
                            className: "support-faqs__ask-button",
                            onClick: () => handleAskQuestion(faq),
                        },
                        "Ask",
                    ),
                ),
            ),
        ),
    );
};

export default FAQs;
